__turbopack_context__.v({
  "outliner": "scene-objects-module__Tv09KW__outliner",
  "root": "scene-objects-module__Tv09KW__root",
});
